import { useEffect, useCallback } from 'react';

export function useKeyDown(cb, active) {
  useEffect(() => {
    const shouldListen = typeof active === 'function' ? active() : active;
    if (!shouldListen) return () => undefined;

    const handleEvent = ev => cb(ev, ev.key);
    document.addEventListener('keydown', handleEvent);
    return () => document.removeEventListener('keydown', handleEvent);
  }, [cb, active]);
}

export function useEsc(cb, active) {
  const handleKeyDown = useCallback(
    (ev, key) => {
      // Esc is used for IE/Old Edge support. Good browsers use Escape.
      if (['Esc', 'Escape'].includes(key)) {
        cb(ev);
      }
    },
    [cb]
  );

  useKeyDown(handleKeyDown, active);
}

export default useKeyDown;
